import { Component, Inject, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { SubSink } from 'subsink';
import { selectOrganizationState, selectCategoriesState, selectCurrentItemState } from '@app/modules/organization/store/selectors/organization.selectors';
import { OnDestroy } from '@angular/core';
import { SanitizeStringPipe } from '@app/shared/pipes/sanitize-string.pipe';
import { buildCategoryTree, CategoryTreeRow } from '@app/shared/pipes/category-tree.pipe';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnDestroy{
  public form: FormGroup;
  public subs: SubSink = new SubSink();
  // Where the category can go: every category except, when editing, itself
  // and its own sub-categories.
  public parentOptions: CategoryTreeRow[] = [];

  constructor(
    private store$: Store,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      if(this.data.type === 'Add'){
        this.form = new FormGroup({
          prdCatNameEn: new FormControl('', [Validators.required]),
          // "Add sub-category" opens the form with the parent preset.
          prdCatParentID: new FormControl(this.data.parentID || null)
        });
      }else{
        this.form = new FormGroup({
          prdCatNameEn: new FormControl(new SanitizeStringPipe().transform(this.data.area.prdCatNameEn), [Validators.required]),
          prdCatParentID: new FormControl(this.data.area.prdCatParentID || null)
        });
      }

      this.subs.add(
        this.store$.select(selectCategoriesState).subscribe(categories => {
          this.parentOptions = this.buildParentOptions(categories || []);
        })
      );
   }

   ngOnDestroy(){
     this.subs.unsubscribe();
   }

   onSubmit(){
     if(this.form.status === "VALID"){
      if(this.data.type === 'Add'){
        this.store$.dispatch(OrganizationActions.saveCategory({ form: this.form.value }))
       }else{
        this.data.area.prdCatNameEn = this.form.controls['prdCatNameEn'].value;
        this.data.area.prdCatParentID = this.form.controls['prdCatParentID'].value || null;
        if(this.data.area.prdCatNameEn.trim()!=''){
          this.store$.dispatch(OrganizationActions.updateCategory({ form: this.data.area, prdCatID: this.data.area.id }))
        }
       }
     }
     return false;
   }

   onValidateCategoryName(event) {
    let prdCatNameEn = event.target.value.trim();
    if(prdCatNameEn==''){
      return this.form.controls['prdCatNameEn'].setErrors({ "required" : false });
    }
    // ">" separates the levels of a category path in import and export.
    if(prdCatNameEn.includes('>')){
      return this.form.controls['prdCatNameEn'].setErrors({ "separator" : true });
    }
  }

  private buildParentOptions(categories: any[]): CategoryTreeRow[] {
    const rows = buildCategoryTree(categories);
    if (this.data.type === 'Add') {
      return rows;
    }

    // Skip the category being edited and everything below it.
    const editedID = +this.data.area.prdCatID;
    const excluded = new Set<number>([editedID]);
    rows.forEach(row => {
      if (excluded.has(+(row.category.prdCatParentID || 0))) {
        excluded.add(+row.category.prdCatID);
      }
    });

    return rows.filter(row => !excluded.has(+row.category.prdCatID));
  }
}
